module.exports = __webpack_public_path__ + "static/media/chevron-down.ffdd096f.svg";